const get_note_popup_data = "calendar/calendar-events"
module.exports = {
    getEventPopupData: function getNotePopup(event_id,from_page,start_date, end_date,start_time, contractor_ids_value) {
        return window.axios.get(get_note_popup_data, {
            params: {
                event_id: event_id,
                from_page: from_page,
                start: start_date,
                end: end_date,
                start_time: start_time,
                contractor_ids_value: contractor_ids_value
            }
        });
    },
    saveCalendarEvents: (data)=>{
        return window.axios.post('calendar/save-calendar-events', data);
    }
};